export default __webpack_public_path__ + "static/media/checkmark.327d7018.png";